import { render, staticRenderFns } from "./FreightBillPop.vue?vue&type=template&id=f10db12a"
import script from "./FreightBillPop.vue?vue&type=script&lang=js"
export * from "./FreightBillPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f10db12a')) {
      api.createRecord('f10db12a', component.options)
    } else {
      api.reload('f10db12a', component.options)
    }
    module.hot.accept("./FreightBillPop.vue?vue&type=template&id=f10db12a", function () {
      api.rerender('f10db12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FreightBillPop.vue"
export default component.exports